exports.mobileStrategy = (strategy) => {
  return strategy == 'mobile';
};
